// extracted by mini-css-extract-plugin
export default {"container":"UG-z","disabled":"VG-z","bgBlack":"WG-z","content":"XG-z","countdown":"YG-z","topCaption":"ZG-z","topHeading":"_G-z","heading":"aH-z","copy":"bH-z"};